export const VENDOR_STATUS = {
    ACTIVE: "ACTIVE",
    DEACTIVATED: "DEACTIVATED",
};

export const VENDOR_STATUSES = [
    { id: "ACTIVE", label: "active", color: "#33B950" },
    { id: "IN_ACTIVE", label: "deactivated", color: "#C4C4C4" },
];
